(function(w,d){
  'use strict';
  var host=d.currentScript;
  var src=host&&host.getAttribute('data-global-src');
  var jgrowlSrc=host&&host.getAttribute('data-jgrowl-src');
  var loading=false,loaded=false,pending=null;
  var modalLoading=false,modalLoaded=false,modalWaiters=[];
  if(!src)return;

  function markButtonLoading(button){
    if(!button)return;
    if(!button.getAttribute('data-ice-original-label')){
      button.setAttribute('data-ice-original-label',(button.textContent||'').trim()||'Add To Cart');
    }
    button.setAttribute('aria-busy','true');
    button.setAttribute('aria-live','polite');
    button.classList.remove('ice-cart-added','ice-cart-error');
    button.classList.add('ice-cart-loading');
    button.textContent='Adding…';
  }

  function findButton(node){
    while(node&&node!==d){
      if(node.nodeType===1&&(' '+(node.className||'')+' ').indexOf(' add-to-cart ')!==-1)return node;
      node=node.parentNode;
    }
    return null;
  }

  function replay(){
    if(!pending)return;
    var button=pending;
    pending=null;
    w.setTimeout(function(){
      if(w.jQuery)w.jQuery(button).trigger('click');
      else if(typeof button.click==='function')button.click();
    },0);
  }

  function getModalSrc(){
    var config=d.getElementById('ice-addcart-modal-config');
    if(!config)return '';
    try{return JSON.parse(config.textContent||'')||'';}catch(err){return '';}
  }

  function flushModalWaiters(){
    var callbacks=modalWaiters.slice(0);
    modalWaiters.length=0;
    for(var i=0;i<callbacks.length;i++){
      try{callbacks[i]();}catch(err){}
    }
  }

  function ensureModal(next){
    if(d.getElementById('layer-addcart-modal')){
      modalLoaded=true;
      next();
      return;
    }
    if(modalLoaded){next();return;}
    if(modalLoading){modalWaiters.push(next);return;}

    var modalSrc=getModalSrc();
    if(!modalSrc&&d.readyState==='loading'){
      d.addEventListener('DOMContentLoaded',function(){ensureModal(next);},{once:true});
      return;
    }
    if(!modalSrc){next();return;}

    modalLoading=true;
    modalWaiters.push(next);
    var s=d.createElement('script');
    s.src=modalSrc;
    s.async=true;
    s.onload=function(){
      modalLoaded=!!d.getElementById('layer-addcart-modal');
      modalLoading=false;
      flushModalWaiters();
    };
    s.onerror=function(){
      modalLoading=false;
      flushModalWaiters();
    };
    d.head.appendChild(s);
  }

  function loadGlobal(){
    var s=d.createElement('script');
    s.src=src;
    s.async=true;
    s.onload=function(){loaded=true;loading=false;replay();};
    s.onerror=function(){
      loading=false;
      if(pending&&pending.href)w.location.href=pending.href;
      pending=null;
    };
    d.head.appendChild(s);
  }

  function ensureJGrowl(){
    if(!jgrowlSrc||(w.jQuery&&typeof w.jQuery.jGrowl==='function')){
      loadGlobal();
      return;
    }
    var s=d.createElement('script');
    s.src=jgrowlSrc;
    s.async=true;
    s.onload=loadGlobal;
    s.onerror=loadGlobal;
    d.head.appendChild(s);
  }

  function load(){
    if(loading||loaded)return;
    loading=true;
    ensureModal(ensureJGrowl);
  }

  d.addEventListener('click',function(e){
    if(loaded)return;
    var button=findButton(e.target);
    if(!button)return;
    e.preventDefault();
    e.stopPropagation();
    if(typeof e.stopImmediatePropagation==='function')e.stopImmediatePropagation();
    markButtonLoading(button);
    pending=button;
    load();
  },true);

  d.addEventListener('mouseover',function(e){if(!loaded&&findButton(e.target))load();},true);
  d.addEventListener('focusin',function(e){if(!loaded&&findButton(e.target))load();},true);
  d.addEventListener('touchstart',function(e){if(!loaded&&findButton(e.target))load();},{capture:true,passive:true});
}(window,document));
